function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { formValues } from 'redux-form';

var visibleIf = function visibleIf(Component, valueKey) {
  var _ref2, _VisibleIf$defaultPro;

  var isNegated = valueKey[0] === '!';
  var key = isNegated ? valueKey.slice(1) : valueKey;

  var VisibleIf = function VisibleIf(_ref) {
    var value = _ref[key],
        rest = _objectWithoutProperties(_ref, [key]);

    return (isNegated ? !value : value) ? React.createElement(Component, rest) : null;
  };

  VisibleIf.propTypes = process.env.NODE_ENV !== "production" ? (_ref2 = {}, _ref2[key] = PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]), _ref2) : {};
  VisibleIf.defaultProps = (_VisibleIf$defaultPro = {}, _VisibleIf$defaultPro[key] = false, _VisibleIf$defaultPro);
  return formValues(key)(VisibleIf);
};

export { visibleIf };
export var validateIf = function validateIf(validate, valueKey) {
  return function (val, allVals) {
    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    var isNegated = valueKey[0] === '!';
    var key = isNegated ? valueKey.slice(1) : valueKey;
    return (isNegated ? !allVals[key] : allVals[key]) ? validate.apply(undefined, [val, allVals].concat(rest)) : undefined;
  };
};